#import "./TrainingModuleAdminFields.graphql"

mutation ArchiveTrainingModule($moduleId: ID!) {
  archiveTrainingModule(input: { moduleId: $moduleId }) {
    trainingModule {
      ...TrainingModuleAdminFields
    }
  }
}
